import $ from 'jquery'

class CareerContent {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		// $(document).ready(function () {
		if (window.innerWidth > 765) {
			myObj.CareerContentFunction()
		}
		// })
	}

	//? 3. methods (functions)
	CareerContentFunction() {
		console.log('CareerContent')

		let distance = -($('.getHeight').height() - 350)
		// if (window.innerWidth > 992) {
		// 	distance = -550
		// }

		let contentTL = new TimelineMax()
		contentTL.to('.content-col', 5, { y: distance })

		// // init controller
		var controller = new ScrollMagic.Controller()

		// build scene
		var scene = new ScrollMagic.Scene({
			triggerElement: '#career-content',
			// offset: 0,
			triggerHook: 'onLeave',
			duration: window.innerHeight * 1.5,
		})
			.setTween(contentTL) // trigger a TweenMax.to tween
			// .addIndicators({ name: '1 (duration: 0)' })
			.setPin('#career-content')
			.addTo(controller)
	}
}

export default CareerContent
